import React from 'react';

const StatCard = ({ title, value, description, color }) => {
 return (
 <div className="bg-[#1a1a1a] text-white p-6 rounded-xl shadow-md w-full">
 <h4 className="text-sm text-muted mb-1">{title}</h4>
 <h2 className="text-3xl font-bold text-gold">{value}</h2>
 <p className={`text-sm ${color}`}>{description}</p>
 </div>
 );
};

export default StatCard;



